import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid, IconButton, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { format, parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { LoadingComp } from "../../../../shared/components/loading/Loading";
import { ISinisterNegotiationInteraction, SinisterNegotiationService } from "../../../../shared/services/api/sinister/SinisterNegotiationService";
import { getNegotiationInteractionLabel } from "../../constants/negotiationInteractionTypes";

interface Props {
	open: boolean;
	sinisterId: string;
	onClose: () => void;
}

export const ModalInteractionsHistory = ({ open, sinisterId, onClose }: Props) => {
	const [interactions, setInteractions] = useState<ISinisterNegotiationInteraction[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (!open) return;
		setIsLoading(true);
		SinisterNegotiationService.getInteractions(sinisterId)
			.then((result) => {
				if (!(result instanceof Error)) setInteractions(result);
			})
			.finally(() => setIsLoading(false));
	}, [open, sinisterId]);

	return (
		<>
			<LoadingComp isopen={isLoading} />
			<Modal open={open} onClose={onClose}>
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						bgcolor: "background.paper",
						boxShadow: 24,
						p: 3,
						width: "90%",
						maxWidth: 800,
						maxHeight: "90vh",
						overflowY: "auto",
						borderRadius: 2,
					}}
				>
					<Grid container justifyContent="space-between" alignItems="center" mb={2}>
						<Typography variant="h6">Histórico de Ações do Sinistro</Typography>
						<IconButton onClick={onClose} size="small">
							<CloseIcon />
						</IconButton>
					</Grid>

					{interactions.length === 0 ? (
						<Typography variant="body2" color="text.secondary">
							Nenhuma ação registrada ainda.
						</Typography>
					) : (
						<TableContainer>
							<Table size="small">
								<TableHead>
									<TableRow sx={{ backgroundColor: "grey.100" }}>
										<TableCell>Data</TableCell>
										<TableCell>Tipo</TableCell>
										<TableCell>Observação</TableCell>
										<TableCell>Retornar em</TableCell>
										<TableCell>Operador</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{interactions.map((interaction) => (
										<TableRow key={interaction.id} hover>
											<TableCell>{format(parseISO(interaction.createdAt), "dd/MM/yyyy HH:mm")}</TableCell>
											<TableCell>{getNegotiationInteractionLabel(interaction.type)}</TableCell>
											<TableCell>{interaction.note ?? "-"}</TableCell>
											<TableCell>{interaction.returnAt ? format(parseISO(interaction.returnAt), "dd/MM/yyyy") : "-"}</TableCell>
											<TableCell>{interaction.userName ?? "-"}</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					)}
				</Box>
			</Modal>
		</>
	);
};
